/**
 * LangChain browser exports
 */

/**
 * LangChain Messages
 */
export {
  BaseMessage,
  BaseMessageChunk,
  AIMessage,
  AIMessageChunk,
  SystemMessage,
  SystemMessageChunk,
  HumanMessage,
  HumanMessageChunk,
  ToolMessage,
  ToolMessageChunk,
  type ContentBlock,
  filterMessages,
  trimMessages,
} from "@langchain/core/messages";

/**
 * Universal Chat Model
 */
export { initChatModel } from "./chat_models/universal.js";

/**
 * LangChain Tools
 */
export {
  Tool,
  type ToolRuntime,
  DynamicTool,
  StructuredTool,
  DynamicStructuredTool,
} from "@langchain/core/tools";

/**
 * LangChain tool primitive (supports both normal and headless tools)
 */
export {
  tool,
  type HeadlessTool,
  type HeadlessToolFields,
  type HeadlessToolImplementation,
} from "./tools/headless.js";

/**
 * LangChain utilities
 */
export { context } from "@langchain/core/utils/context";

/**
 * LangChain Agents
 */
export * from "./agents/index.js";

/**
 * `createAgent` pre-built middleware
 */
export * from "./agents/middleware/index.js";

/**
 * LangChain Stores
 */
export { InMemoryStore } from "@langchain/core/stores";

/**
 * LangChain Documents
 */
export { type DocumentInput, Document } from "@langchain/core/documents";

/**
 * LangChain Testing Utilities
 */
export {
  langchainMatchers,
  type LangChainMatchers,
  fakeModel,
} from "@langchain/core/testing";
